import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import antiClock from "../../assets/images/anticlock.png";
import { getOTP, switchPatient, verifyMobileOTP } from "../../actions/post-call";
import { getProfile } from "../../actions/get-calls";

import { setCallTokenReducer } from "../../redux/slice/call-token";
import { setSwitchTokenReducer } from "../../redux/slice/switch-token";
import { setAllUsersReducer } from "../../redux/slice/all-users";
import { setSelectedUserReducer } from "../../redux/slice/selected-user";
import { setUserProfileReducer } from "../../redux/slice/user-profile";

const LoginUser = ({ registeredState, setOtpVerified, setMobile }) => {

  const [mobileNumber, setMobileNumber] = useState('');
  const [currentOTP, setCurrentOTP] = useState('');
  const [showOTP, setShowOTP] = useState(false);

  const [timeLeft, setTimeLeft] = useState(30);
  const [isResend, setIsResend] = useState(false);
  const [firstTimeOtpSendLoader,setFirstTimeOtpLoader] = useState(false)
  const dispatch = useDispatch();
  const selectedUser = useSelector((state) => state.selectedUser.value);

  useEffect(() => {
    if (selectedUser) {
      return registeredState(true);
    }
  }, [selectedUser]);

  function handleOtpRequest() {
    console.log('mobileNumber: ', mobileNumber);
    if(mobileNumber){
      setFirstTimeOtpLoader(true)
      getOTP(mobileNumber)
      .then(function (x_response) {
        let x_res = x_response.data;
        setFirstTimeOtpLoader(false)
        
        if (x_res && x_res.errors) {
          console.log('Not Registerdd');
          registeredState(false);
          setMobile(mobileNumber);
          return false;
        }
        console.log('Registerd ');
        
        setIsResend(true);
        setTimeLeft(30);
        setShowOTP(true);
      })
      .catch(function () {
        setFirstTimeOtpLoader(false)
        
       });
    }

  }

  function verifyOTP() {
    verifyMobileOTP({ isd_code: "91", otp: currentOTP, uid: mobileNumber })
      .then(function (login_response) {
        let login_res = login_response.data;
        let firstToken = login_response.headers.authorization;

        if (login_res.errors && login_res.errors.length > 0) {
          return showToast(login_res.errors[0].message);
        }

        dispatch(setCallTokenReducer(firstToken));
        dispatch(setAllUsersReducer(login_res.users));

        if (login_res && login_res.users && login_res.users.length > 1) {
          switchPatient({ patient_id: login_res.users[0].id }, firstToken)
            .then(function (switch_response) {
              let switch_token = switch_response.headers.authorization;
              let switch_res = switch_response.data;

              if (switch_response && switch_res && switch_res.errors && switch_res.errors.length > 0) {
                return showToast(switch_res.errors[0].message);
              }

              dispatch(setSwitchTokenReducer(switch_token));
              dispatch(setSelectedUserReducer(switch_res.user));

              getProfile(switch_token)
                .then(function (profile_response) {
                  let profile_res = profile_response.data;

                  if (profile_response && profile_res && profile_res.errors && profile_res.errors.length > 0) {
                    return showToast(profile_res.errors[0].message);
                  }

                  if (profile_response && profile_res) {
                    dispatch(setUserProfileReducer(profile_res.user));
                  }
                }).catch(function (err) { });
            }).catch(function (err) { });
        } else {
          getProfile(firstToken)
            .then(function (profile_response) {
              let profile_res = profile_response.data;

              if (profile_res && profile_res.errors && profile_res.errors.length > 0) {
                return showToast(profile_res.errors[0].message);
              }

              if (profile_res) {
                dispatch(setSelectedUserReducer(profile_res.user));
              }
            }).catch(function (err) { });
        }

        setIsResend(false);
        timeLeft(30);
        setOtpVerified(true);
        setShowOTP(false);
      }).catch(function (err) { });
  }

  useEffect(() => {
    let timer = setInterval(() => {
      if (isResend) {
        if (timeLeft > 0) {
          setTimeLeft(timeLeft - 1)
        } else {
          clearInterval(timer);
          setIsResend(false);
          setTimeLeft(30);
        }
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  });

  function showToast(str) {
    toast.error(str, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false
    });
  }

  return (
    <React.Fragment>
      <ul className={showOTP === false ? "list-unstyled d-flex flex-wrap list-login mb-0" : "list-unstyled d-flex justify-content-between list-login mb-0"}>
        <li>
          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              value={mobileNumber}
              maxLength="10"
              id="mobileNumber"
              name="mobileNumber"
              placeholder="Enter mobile number"
              onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
            <label htmlFor="name">
              Mobile <sup>*</sup>
            </label>
          </div>
        </li>
        {
          showOTP === false ? (
            <li>
              <button className="btn btn-outline-primary rounded-1 mx-2" onClick={() => handleOtpRequest()} disabled={firstTimeOtpSendLoader}>{firstTimeOtpSendLoader ?'Checking...':'Continue'}</button>
            </li>
          ) : (
            <>
              <li>
                <div className="form-floating ms-0 ms-md-2 mt-4 mt-md-0">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="4"
                    value={currentOTP}
                    id="OTP"
                    name="OTP"
                    placeholder="Enter OTP"
                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
                    onChange={(e) => setCurrentOTP(e.target.value)}
                  />
                  <label htmlFor="name">OTP <sup>*</sup></label>
                </div>
              </li>
              <li>
                <button className="btn btn-outline-primary rounded-1" style={{ marginLeft: '1rem' }} onClick={() => verifyOTP()}>Verify OTP</button>
              </li>
            </>
          )
        }
      </ul>

      {
        showOTP && (
          <div className="row  mt-4">
            <div className="col-md-6 col-lg-6">
              <p className="m-0">An OTP has been sent to your mobile number, please enter to verify.</p>
            </div>
            <div className="col-md-6 col-lg-6 mt-3 mt-md-0">
              <div className="d-flex align-items-center justify-content-start justify-content-md-end">
                {
                  isResend ? (
                    <div className="anitClock">
                      <img src={antiClock} className="anti-img" alt="" />
                      <p className="otp-time">{timeLeft}</p>
                    </div>
                  ) : (
                    <button onClick={() => handleOtpRequest()} className="text-primary btn-link fs-6 text-decoration-none text-nowrap" disabled={isResend||firstTimeOtpSendLoader}>{isResend||firstTimeOtpSendLoader?'Sending OTP...':'Resend OTP'}</button>
                  )
                }
              </div>
            </div>
          </div>
        )
      }
      <ToastContainer />
    </React.Fragment>
  );
};

export default LoginUser;
